import { CLEAN_SALE_ORDERS, CLEAN_SALE_ORDERS_ERROR } from '_models/redux/types';

export const cleanSaleOrdersAction = () => async (dispatch) => {
  try {
    dispatch({
      payload: undefined,
      type: CLEAN_SALE_ORDERS,
    });
  } catch (e) {
    dispatch({
      payload: undefined,
      type: CLEAN_SALE_ORDERS_ERROR,
    });
  }
};
